<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear semester ssystem college department sclass keyword="學號、學生姓名">
                    <div class="col-md col-sm-12">
                        <form-select v-model="query.Job" id="Job" label="職務">
                            <div is="option" value="">全部</div>
                            <div is="option" v-for="o in jobs" :key="o.key" :value="o.key">{{o.value}}</div>
                        </form-select>
                    </div>
                </query>
                <btn-group :load="reload" :insert="insert" :del="del" :deleteItems="deleteItem.length" :input="input" :file="file">
                </btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>學年度-學期</th>
                            <th>班級</th>
                            <th>職務</th>
                            <th>學號-學生姓名</th>
                            <th>電話</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.ClassCadreID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.ClassCadreID" /></td>
                        <td data-th="學年度-學期">{{item.SYear}}-{{item.Semester|semester}}</td>
                        <td data-th="班級">{{item.ClassName}}</td>
                        <td data-th="職務">{{item.Job|job}}</td>
                        <td data-th="學號-學生姓名"><b-button size="sm" variant="link" @click="edit(item.ClassCadreID)">{{item.StudentNo}}-{{item.StudentName}}</b-button></td>
                        <td data-th="電話">{{item.Tel}}</td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload" @edit="edit">
            <template slot="job">
                <div is="option" v-for="o in jobs" :key="o.key" :value="o.key">{{o.value}}</div>
            </template>
        </Detail>
        <inputmodal id="input" sample="/template/classcadre.xlsx" url="/api/classcadre/excel" @ok="reload()"></inputmodal>
    </page-main>
</template>

<script>
    import Detail from './classcadreDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'classcadre',
        api: '/api/classcadre/',
        components: { Detail },
        data: { jobs: [] },
        created: function () {
            window.jobs = [];
            this.$parameter.classcadre().then((res) => { window.jobs = this.jobs = res.data; });
        },
        filters: {
            job: function (value) { let a = window.jobs.filter(x => x.key == value); return a.length > 0 ? a[0].value : ''; }
        },
        methods: {
            file: function () {
                const $a = document.createElement("a");
                $a.href = this.$apiurl + "/api/classcadre/output?" + new URLSearchParams(this.query).toString();
                $a.click();
            }
        }
    });
</script>

<style>
</style>